<template>
    <iom-form :iom-uuid="$route.params.uuid"></iom-form>
</template>

<script>
import IomForm from "@/views/pages/dashboard/iom/IomForm";

export default {
    name: "edit",
    components: {
        IomForm,
    },
}
</script>
